import { config } from './config';
import type { StyleText, Voice } from './types';

export async function getVoices(): Promise<Voice[]> {
  const resp = await fetch(`${config.static.public_base_url}/voices.json`, {
    method: 'GET',
  });

  const voices = ((await resp.json()) as Voice[]).map((v: Voice) => ({
    ...v,
    models: v.models.filter(
      (m) => m.languages.length > 0 && m.name !== 'simba-base',
    ),
  }));

  return voices
    .filter((voice) => voice.models.length > 0)
    .map((voice) => ({
      ...voice,
      models: voice.models,
    }));
}

export async function getStyles(): Promise<StyleText> {
  const resp = await fetch(`${config.static.public_base_url}/style.json`, {
    method: 'GET',
  });

  return await resp.json();
}

export async function getManifest(): Promise<string[]> {
  const resp = await fetch(
    `${config.static.public_base_url}/assets/manifest.json`,
    {
      method: 'GET',
    },
  );
  return await resp.json();
}
